
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:block;
  border-radius:var(--sic-promo--default--border-radius);
  border-radius:var(
    --sic-promo--border-radius,
    var(--sic-promo--default--border-radius)
  );
  overflow:hidden;
  --sic-body-text--font-size:var(--sic-promo--default--text-size);
  --sic-body-text--line-height:var(--sic-promo--default--text-line-height);
}
.promo-wrapper{
  display:grid;
  grid-template-columns:repeat(2, 50%);
  grid-template-rows:1fr;
  grid-column-gap:0px;
  grid-row-gap:0px;
}
.content-wrapper{
  align-self:center;
}
.content{
  padding:var(--sic-promo--default--content-padding);
  padding:var(
    --sic-promo--content-padding,
    var(--sic-promo--default--content-padding)
  );
}
.body{
  font-size:var(--sic-promo--default--text-size);
  font-size:var(--sic-promo--text-size, var(--sic-promo--default--text-size));
  line-height:var(--sic-promo--default--text-line-height);
  line-height:var(
    --sic-promo--text-line-height,
    var(--sic-promo--default--text-line-height)
  );
  padding-top:var(--sic-promo--default--text-spacing);
  padding-top:var(
    --sic-promo--text-spacing,
    var(--sic-promo--default--text-spacing)
  );
}
.body p{
    margin:0 0 var(--sic-promo--default--text-size);
    margin:0 0 var(--sic-promo--text-size, var(--sic-promo--default--text-size));
  }
.body p:last-child{
      margin-bottom:0;
    }
.cta{
  padding-top:var(--sic-promo--default--cta-spacing);
  padding-top:var(
    --sic-promo--cta-spacing,
    var(--sic-promo--default--cta-spacing)
  );
}
.promo-image{
  width:100%;
  max-width:748px;
  margin-left:auto;
}
.image{
  position:relative;
  height:100%;
}
.image > div{
    display:flex;
    height:100%;
  }
.image img{
    height:100%;
    width:100%;
    object-fit:cover;
  }
.layout-stacked{
  display:block;
}
.layout-stacked .content-wrapper{
    width:100%;
  }
.layout-stacked .image-wrapper{
    max-width:none;
  }
.layout-stacked .image{
    display:block;
  }
.layout-stacked .image > div{
      display:block;
    }
.layout-stacked ::slotted([slot='cta']){
    width:100% !important;
  }
.layout-media-first .promo-image{
    margin-left:0;
  }
@media (min-width: 1920px){
  .promo-wrapper{
    grid-template-columns:1.5fr 1fr;
  }

    .promo-wrapper.layout-media-first{
      grid-template-columns:1fr 1.5fr;
    }
}
`;